export const TOTAL_SECONDS = 60
export const POLL_INTERVAL_MS = 3000
export const DRAWER_ID = 'watch-pairing-drawer'

export const formatCode = code => code ? `${code.slice(0, 3)}-${code.slice(3)}` : ''
